import { Body, PrimaryLinkStyle } from 'components/styled/typography'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import React from 'react'

const StyledWrapper = styled.div`
  a {
    ${PrimaryLinkStyle};
    color: ${({ theme }) => theme.color.primary110};
  }
`

function getHtmlWithNewLinks(html) {
  const rx = /<\s*a href="http[^>]*>(.*?)<\s*\/\s*a>/g
  const links = html.match(rx) || []
  links.forEach((link) => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(link, 'text/html')
    const linkElement = doc.getElementsByTagName('a')[0]
    linkElement.setAttribute('target', '_blank')
    linkElement.setAttribute('rel', 'noopener noreferrer')
    html = html.replace(link, linkElement.outerHTML)
  })
  return html
}

function Html({ html, ...props }) {
  const htmlWithNewLinks = getHtmlWithNewLinks(html)
  // TODO: replace dangerouslySetInnerHTML
  return (
    <StyledWrapper>
      <Body {...props} dangerouslySetInnerHTML={{ __html: htmlWithNewLinks }} />
    </StyledWrapper>
  )
}

Html.propTypes = {
  html: PropTypes.string,
}

Html.defaultProps = {
  html: undefined,
}
export default Html
